import store from '@/store';
import Vue from 'vue';
import VueRouter from 'vue-router';
import { paths } from './paths';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  routes: paths,
});

router.beforeEach(async (to, from, next) => {
  const isUserLoggedIn = store.getters['auth/isAuthenticated'];
  document.title = to.meta?.pageTitle;
  await store.dispatch('snackBarVisibility', false, { root: true });
  await store.dispatch('isLoading', false, { root: true });
  if (to.path !== from.path) {
    await store.dispatch('closeAllDialogs');
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    store.commit('UPDATE_REDIRECT_URL', to.fullPath, {
      root: true,
    });
    if (!isUserLoggedIn) {
      await store.dispatch('auth/logOut', null);
      next({
        path: '/signin',
        query: {
          redirect: to.fullPath,
        },
      });
    } else if (
      // sub-accounts get credit from their reseller; billing pages are not theirs
      to.matched.some((record) => record.meta.hideForSubAccount) &&
      store.getters['auth/getUserDetails']?.isSubAccount
    ) {
      next({ name: 'account.dashboard' });
    } else next();
  } else next();
});

export default router;
